import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TutorSidebarComponent } from './tutor-sidebar/tutor-sidebar.component';

@NgModule({
  declarations: [SidebarComponent, TutorSidebarComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
    RouterModule,
    MatTooltipModule,
    TranslateModule
  ],
  exports: [SidebarComponent, TutorSidebarComponent]
})
export class SharedModule { }
